import { toast } from "sonner";

// `navigator.clipboard.writeText` is permissions-policy gated and rejects in
// locked-down browsers / missing-user-gesture contexts. Awaiting + branching
// the toast keeps the UI honest when the write actually fails.
export async function copyToClipboardWithToast(text: string): Promise<void> {
    try {
        await navigator.clipboard.writeText(text);
        toast.success("Copied to clipboard");
    } catch {
        toast.error("Couldn't copy to clipboard");
    }
}
